import Swal from "sweetalert2";

/**
 * Helper copiar objetos
 * @param typeBlob: respuesta tipo blog
 * @param nombre: nombre del archivo
 * @author Paul
 */
window.downloadFile = function (typeBlob, name, extension = null) {
    const isCorrect = typeBlob instanceof Blob
    if (!isCorrect) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se puede generar el archivo',
            showConfirmButton: true,
            timer: 5000
        });
        return;
    }

    let blob = new Blob([typeBlob], {
        "type": "application/octet-stream"
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const download =  extension ? name + extension : name;
    link.download = download
    document.body.append(link);
    link.click();
}


/**
 * Helper copiar objetos
 * @param obj {}
 * @author Paul
 */
window.clone = function (obj) {
    return JSON.parse(JSON.stringify(obj))
}

/**
 * Helper construir objetos
 * @param obj {}
 * @author Paul
 */
window.buildFormData = function (obj) {
    const formData = new FormData();
    for (let prop in obj) {
        formData.append(prop, obj[prop])
    }
    return formData
}

/**
 * Helper construir objetos para tratar imagenes, insertando excepciones
 * @param obj, exception = []
 * @author Paul
 */
window.buildFormDataUpdate = function (obj, exception) {
    const formData = new FormData();
    for (let prop in obj) {
        if (exception.includes(prop)) {
            if (obj[prop]) {
                formData.append(prop, obj[prop])
            }
        } else {
            formData.append(prop, obj[prop])
        }
    }
    return formData
}

/**
 * Obtener extension archivo.
 * @param file e.target.files[0].name
 * @author Paul
 */
window.getExtensionFile = function (nameFile) {
    const arrNameFile = nameFile.split(".");
    const ext = arrNameFile.at(-1)
    return ext;
}

/**
 * Mostrar lista de errores del backend.
 * @param error
 * @author Paul
 */
window.listErrors = function (error) {
    let htmlErrors = '<ul style="margin-bottom: 0rem">';
    const errorMessages = Object.values(error.errors);

    errorMessages[0].forEach(error => {
        htmlErrors += `<li>${error}</li>`
    })

    htmlErrors += '</ul>'
    return htmlErrors;
}
